import api from './api';

export const motivationService = {
    // Tüm motivasyon mesajlarını getir
    getAllMessages: async (page = 1, limit = 20, status = '') => {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            ...(status && { status })
        });

        const response = await api.get(`/admin/motivational-messages?${params}`);
        return response.data;
    },

    // Yeni motivasyon mesajı ekle
    addMessage: async (title, content, is_active = true) => {
        const response = await api.post('/admin/motivational-messages', {
            title,
            content,
            is_active
        });
        return response.data;
    },

    // Motivasyon mesajını güncelle
    updateMessage: async (messageId, title, content, is_active) => {
        const response = await api.put(`/admin/motivational-messages/${messageId}`, {
            title,
            content,
            is_active
        });
        return response.data;
    },

    // Motivasyon mesajını sil
    deleteMessage: async (messageId) => {
        const response = await api.delete(`/admin/motivational-messages/${messageId}`);
        return response.data;
    },

    // Mesaj durumunu değiştir
    toggleMessageStatus: async (messageId, isActive) => {
        const response = await motivationService.updateMessage(messageId, null, null, isActive);
        return response.data;
    }
};